import React, { Component } from 'react';
import { InputNumber, Row, Col} from 'antd';
import {
  To_String,
  isInteger,
  isDouble,
  multime,
} from '@/utils/common';


import config from '@/config';
const notice = config.notice;

class PositionInputNumber extends Component {
  render () {
    let {
      label,
      name,
      value,
      step,
      unit,
      area,
      handleNumberChange,
    } = this.props;

    return (
      <Row>
        <Col span={8} className="property">
          { label }
        </Col>
        <Col span={3} className="maohao">:</Col>
        <Col span={9} className="value">
          <InputNumber
            {...this.props}
            size="small"
            min={0}
            step={step}
            value={value}
            style={{width: 62}}
            // formatter={value => `${value}${unit}`}
            // parser={value => value.replace(`${unit}`, '')}
            formatter={value => `${value}`}
            // parser={value => value.replace(`${unit}`, '')}
            onChange={(value) =>　{
              handleNumberChange && handleNumberChange(value, area, name);
            }}
          />
        </Col>
        <Col span={4}>
        </Col>
      </Row>
    )
  }
}
export default class AreaPosition extends Component {
  render() {
    let { currentArea: area } = this.props;
    let areaPlaytime = '00:00:00';

    (area.mediaAreas || []).forEach((mediaArea) => {
      let { playtime } = mediaArea;
      if('' === playtime || '--' === playtime){
        playtime = '00:00:00';
      }
      areaPlaytime = multime(areaPlaytime, playtime);
    });
    let { areaType, areaName,
      left, top, width, height,
      leftPcnt, topPcnt, widthPcnt, heightPcnt, } = area;
    let areaPositionComb = (
      <div className={"playlist-property-area"}>
        <Row className="playlist-property-area-name">
          <Col span={2}>
          </Col>
          <Col span={9}>
            <Row>
              <Col span={8} className="property">
               { window.language['playlist.duration'] }
              </Col>
              <Col span={3} className="maohao">:</Col>
              <Col span={13} className="value">
                { areaPlaytime }
              </Col>
            </Row>
          </Col>
          <Col span={13}>
          </Col>
        </Row>
        <Row className="playlist-property-area-position1">
          <Col span={2}>
          </Col>
          <Col span={9}>
            <PositionInputNumber 
              {...this.props}
              disabled={ 9 === areaType ? true : false}
              label = { window.language['playlist.Xaxis'] }
              name = { 'left' }
              value={ left }
              unit = { 'px' }
              step = { 10 }
              area = { area } />
          </Col>
          <Col span={2}>
          </Col>
          <Col span={9}>
            <PositionInputNumber 
              {...this.props}
              disabled={ 9 === areaType ? true : false}
              label = { window.language['playlist.Yaxis'] }
              name = { 'top' }
              value={ top }
              step = { 10 }
              unit = { 'px' }
              area = { area } />
          </Col>
          <Col span={2}>
          </Col>
        </Row>
        <Row className="playlist-property-area-position2">
          <Col span={2}>
          </Col>
          <Col span={9}>
            <PositionInputNumber 
              {...this.props}
              disabled={ 3 === areaType || 4 === areaType || 5 === areaType || 9 === areaType ? true : false}
              label = { window.language['playlist.width']}
              name = { 'width' }
              value={ width }
              step = { 10 }
              unit = { 'px' }
              area = { area } />
          </Col>
          <Col span={2}>
          </Col>
          <Col span={9}>
            <PositionInputNumber 
              {...this.props}
              disabled={ 3 === areaType || 4 === areaType || 5 === areaType || 9 === areaType ? true : false}
              label = { window.language['playlist.height'] }
              name = { 'height' }
              value={ height }
              step = { 10 }
              unit = { 'px' }
              area = { area } />
          </Col>
          <Col span={2}>
          </Col>
        </Row>
      </div>
    )

    return (
      areaPositionComb
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Playlist/AreaPosition.js